import { DateMarshaller } from 'app/constants/schemas/Date';
import { StaffProfile, IStaffProfile } from 'app/constants/schemas/StaffProfile';
import vmClient from 'app/services/vmClient';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';

export interface IIssueComment extends IEntity {
  attributes: {
    id: EntityStringId;
    message: string | null;
    createdAt: Date | null;
    updatedAt: Date | null;
  };
  associations: {
    creator: IStaffProfile | null;
  };
}

export type IssueComment = Entity<IIssueComment>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IssueComment: IEntityType<IIssueComment> = vmClient.defineClass({
  typeName: 'IssueComment',
  version: 2,
  lockable: true,
  persisted: true,
  attributes: {
    message: 'string',
    createdAt: {
      type: Date,
      marshaller: DateMarshaller,
    },
    updatedAt: {
      type: Date,
      marshaller: DateMarshaller,
    },
  },
  associations: {
    creator: {
      type: StaffProfile,
      shared: true,
    },
  },
});
